// extracted by mini-css-extract-plugin
export default {"wrapper":"w9","container":"x9","box":"y9","title":"z9","rdwrap":"A9","rditem":"B9","rdimage":"C9","name":"E9","heading":"F9","text":"G9","guarantee":"H9","chatbox":"I9"};
    if(module.hot) {
      // 1713912568045
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  